import treadDark from './tread-logo-dark.png';
import treadFullDark from './full-tread-dark.png';
import treadRoundedSvg from './tread-logo-rounded.svg';
import treadPortal from './portal-logo.png';
import discord from './discord.svg';
import telegram from './telegram.svg';
import logo from '../../branding/logo.svg';
import hyperunit from './hyperunit.svg';
import hyperliquid from './hyperliquid.svg';

const LOGOS = {
  treadDark,
  treadFullDark,
  treadRoundedSvg,
  logo,
  discord,
  telegram,
  treadPortal,
  hyperunit,
  hyperliquid,
};

export default LOGOS;
